import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { useRewampLocalization, useRewampT } from "../../localisation";
import { PWA_ENTRY } from "../../layouts/pwaConfig";
import { isPwaSignedIn, languagePickerPath } from "../../routes/pwaSession";

const BRAND_IMAGES = ["bihar-krishi.svg", "krishi-sahayak.svg"];

const halfSx = { display: "flex", alignItems: "center", justifyContent: "center", minHeight: 0 };

export default function PwaAppLoader() {
  useRewampLocalization(["common"]);
  const tRewamp = useRewampT();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      const to = isPwaSignedIn() ? `${window.contextPath}/home` : languagePickerPath();
      navigate(to, { replace: true });
    }, PWA_ENTRY.loaderMinMs);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box
      component="main"
      aria-busy="true"
      sx={{
        display: "grid",
        gridTemplateRows: "repeat(2, minmax(0, 1fr))",
        height: "100dvh",
        px: 6.25,
        background: (theme) => theme.palette.background.splashGradient,
      }}
    >
      <Typography component="h1" sx={visuallyHidden}>
        {tRewamp("PWA_APP_LOADER.TITLE")}
      </Typography>
      {BRAND_IMAGES.map((file) => (
        <Box key={file} sx={halfSx}>
          <Box
            component="img"
            src={`${process.env.PUBLIC_URL || ""}/icons/pwa/${file}`}
            alt=""
            aria-hidden="true"
            sx={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </Box>
      ))}
    </Box>
  );
}
